import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import {
  getMesOpportunitesPaginated,
  browseDetailOpportunite } from '@/api/opportunite';
import opportuniteInitialize from '@/services/opportunite/opportuniteInitializer';
import gestionErreur from '@/services/general/gestionErreur';
import { addClients, browseDetailAllDataAffixe2Client } from '@/api/clients';
import { addContact } from '@/api/contacts';
import {
  getSocieteUser,
  createDevisOpp,
  updateDevisOpp,
  GetDevisById,
} from '@/api/devis/index';
import genererDevisCommande from '@/services/devis/genererDevisCommande';
import addIntervenant from '@/services/devis/ajoutIntervenant/addIntervenant';
import creerIntervenant from '@/services/devis/ajoutIntervenant/creerIntervenant';
import ajoutProduitSurDevis from '@/services/devis/ajoutProduit/ajoutProduit';
import preparationEnvoiBack from '@/services/devis/preparationEnvoiBack';
import * as devisConf from '@/configuration/devisConf';
import { clientInitial } from '@/configuration/clientConf';
import contactInitial from '@/configuration/contactInitial';
import { getUsers } from '@/api/login';
import getRegimeTvaDefault from '@/services/devisCommandes/regimeTvaDefault';
import { APPLICATION_TVA_TYPE_NORMAL } from '@/configuration/applicationTvaConf';
import * as types from './opportunites-mutation-type';
import * as typesPanier from '../creationOpportunite/panier-mutation-type';
import * as allTypes from '../mutation-type';


function initialState() {
  return {
    mesOpportunites: [],
    totalOpportunites: 0,
    detailOpportunite: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE]() {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [allTypes.RESET_NOT_PERSISTED](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_MES_OPPORTUNITES](state, mesOpportunites) {
    state.mesOpportunites = mesOpportunites;
  },
  [types.SET_TOTAL_OPPORTUNITES](state, total) {
    state.totalOpportunites = total;
  },
  [types.SET_DETAIL_OPPORTUNITE](state, detailOpportunite) {
    state.detailOpportunite = detailOpportunite;
  },
};

const actions = {
  rechercheMesOpportunites: ({ rootGetters, commit }, payload) => {
    return new Promise((resolve, reject) => {
      getMesOpportunitesPaginated(payload.userId, payload.data).then((response) => {
        const clients = rootGetters['clients/clients'];
        commit(types.SET_TOTAL_OPPORTUNITES, response.headers['x-total-count']);
        response.data.forEach((data) => {
          opportuniteInitialize(data, clients);
          data.date = moment(data.dateCreation).format('DD/MM/YYYY');
          data.dateDeValidite = data.dateValidite ? moment(data.dateValidite).format('DD/MM/YYYY') : '';
          data.url = 'opportunites/' + data.id + '/action/pdf';
          data.urlRecap = 'opportunites/' + data.id + '/action/recap';
          data.urlRecapExcel = 'opportunites/' + data.id + '/action/recap-excel';
          data.afficherRecap = false;
          if (data.data.produits.reseauxTempo.length > 0
            || data.data.produits.reseauxPersonnalise.length > 0) {
            data.afficherRecap = true;
          }
        });
        commit(types.SET_MES_OPPORTUNITES, response.data);
        resolve(response.data);
      }).catch((e) => {
        reject(e.code);
        gestionErreur('Erreur lors de la récupération des opportunités', e);
        throw (e);
      });
    });
  },
  rechercheDetailOpportunite: ({ rootGetters, commit }, payload) => {
    return new Promise((resolve, reject) => {
      browseDetailOpportunite(payload.id).then((response) => {
        const clients = rootGetters['clients/clients'];
        if (response.data) {
          response.data.date = moment(response.data.dateCreation).format('DD/MM/YYYY');
          response.data.dateDeValidite = response.data.dateValidite ? moment(response.data.dateValidite).format('DD/MM/YYYY') : '';
          response.data.url = 'opportunites/' + response.data.id + '/action/pdf';
          response.data.urlRecap = 'opportunites/' + response.data.id + '/action/recap';
          response.data.urlRecapExcel = 'opportunites/' + response.data.id + '/action/recap-excel';
          response.data.afficherRecap = false;
          if (response.data.data.produits.reseauxTempo.length > 0
            || response.data.data.produits.reseauxPersonnalise.length > 0) {
            response.data.afficherRecap = true;
          }
          opportuniteInitialize(response.data, clients);
          commit('panier/' + typesPanier.SET_USER_IDENTIFIANT_OPP, response.data.userId, { root: true });
          commit(types.SET_DETAIL_OPPORTUNITE, response.data);
          resolve();
        } else {
          gestionErreur(`L'opportunité ${payload.id} n'existe pas`);
          resolve();
        }
      }).catch((e) => {
        reject(e.code);
        gestionErreur(`Erreur lors de la récupération des détails de l'opportunité ${payload.id}`, e);
        resolve();
      });
    });
  },
  async genererDevisOpp({ rootGetters }, opp) {
    const isAffixe2 = rootGetters['parametrage/affixe2'];
    if (!isAffixe2) return {};
    let idSociete = rootGetters['user/idSociete'];
    const agenceId = rootGetters['user/agenceId'];
    const userIdentifiantOpp = rootGetters['panier/userIdentifiantOpp'];
    const agences = rootGetters['user/agences'];
    let monAgence;
    if (agences.length) {
      monAgence = agences.find(el => el.agenceId === agenceId);
      if (monAgence) {
        idSociete = monAgence.societeId;
      }
    }
    let idClient = opp.annonceurGuid ? opp.annonceurGuid : opp.annonceurId;
    if (!idClient) {
      const client = cloneDeep(clientInitial);
      client.nomCommercial = opp.data.client.nomCommercial;
      client.adressePostale = opp.data.adresseClient;
      client.societeId = idSociete;
      client.applicationTva = opp.data.client.applicationTva || APPLICATION_TVA_TYPE_NORMAL;
      client.siren = opp.data.client.siren;
      idClient = (await addClients(client)).data.num;
      let estGuid = false;
      if (idClient != null && idClient.includes('-')) {
        estGuid = true;
      }
      opp.annonceurId = estGuid ? null : idClient;
      opp.annonceurGuid = estGuid ? idClient : '';
    }
    if (idClient && opp.data.contact && !opp.data.contact.id) {
      const contact = cloneDeep(contactInitial);
      contact.tiersId = idClient;
      contact.nom = opp.data.contact.nom;
      contact.prenom = opp.data.contact.prenom;
      contact.email = opp.data.contact.email;
      contact.telephone = opp.data.contact.telephone;
      opp.data.contact.id = (await addContact(contact)).data.result.id;
    }
    const societe = await getSocieteUser(idSociete);
    const client = (await browseDetailAllDataAffixe2Client(idClient)).data.result;
    const res = (await getUsers(userIdentifiantOpp)).data;
    const user = res.find(u => u.actif);

    const tauxTvaDefault = await getRegimeTvaDefault(
      idSociete,
      monAgence ? monAgence.regimeTvaId : null,
    );
    const devisCommande = genererDevisCommande(
      devisConf.TYPE_DEVIS,
      devisConf.NORMAL,
      societe,
      agenceId,
      opp.themeCampagne,
      opp.dateValidite,
      user ? parseInt(user.code, 10) : null,
      opp.data.produits,
    );
    let oldDevis = null;
    if (opp.data.devisObject) {
      oldDevis = (await GetDevisById(opp.data.devisObject.id)).data.result;
    }
    addIntervenant(devisCommande, creerIntervenant(client));
    try {
      await ajoutProduitSurDevis(devisCommande, opp, societe, oldDevis, tauxTvaDefault);
    } catch (e) {
      gestionErreur('Erreur lors de l\'ajout des produits sur devis', e);
      throw e;
    }
    if (opp.etatBrouillon) devisCommande.etat = devisConf.ETAT_BROUILLON;
    const devisEnvoi = preparationEnvoiBack(devisCommande);
    let devisResult = {};
    if (opp.data.devisObject) {
      devisEnvoi.id = opp.data.devisObject.id;
      devisEnvoi.code = opp.data.devisObject.code;
      try {
        devisResult = (await updateDevisOpp(opp.id, devisEnvoi)).data.result;
      } catch (e) {
        gestionErreur('Erreur lors de la mise à jour du devis', e);
        throw e;
      }
    } else {
      try {
        devisResult = (await createDevisOpp(opp.id, devisEnvoi)).data.result;
      } catch (e) {
        gestionErreur('Erreur lors de la création du devis', e);
        throw e;
      }
    }
    return devisResult;
  },
};

const getters = {
  mesOpportunites: (state) => {
    return state.mesOpportunites;
  },
  totalOpportunites: (state) => {
    return state.totalOpportunites;
  },
  detailOpportunite: (state) => {
    return state.detailOpportunite;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/mesOpportunites/opportunites.js